module.exports = __webpack_public_path__ + "img/github.ca28ab83.svg";